import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';
import {fetchWithRetry} from '@/utils/fetchWithRetry';

export default async function fetchAuthCredential() {
  const headers = {};
  await addBrowserSideAppHeaders(headers);

  const res = await fetchWithRetry('/api/handle-auth', {
    method: 'POST',
    headers: headers,
  });

  const data: {access_token: string} = await res.json();
  return data.access_token;
}
